import { Component, OnInit } from '@angular/core';
import { fade } from '@core/animations/animations';
import {
	MatterFileType,
	PropertyType,
	MatterPropertyType,
} from '@models/matter';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { UrlService } from 'src/app/shared/services/url/url.service';

@Component({
	selector: 'app-property',
	templateUrl: './property.component.html',
	styleUrls: ['./property.component.scss'],
	animations: [fade()],
	standalone: false,
})
export class PropertyComponent implements OnInit {
	@SelectSnapshot(SelectedMatter.id) saleId: string;
	@ViewSelectSnapshot(SelectedMatter.propertyType)
	propertyType: MatterPropertyType;
	@ViewSelectSnapshot(SelectedMatter.matterFileType) fileType: MatterFileType;

	public propertyTypes = PropertyType;
	public condoCorpUrl: string;
	public detailsUrl: string;
	public complianceLettersUrl: string;
	public fireInsuranceUrl: string;
	public tenancyUrl: string;
	public fileTypes = MatterFileType;

	constructor() {}

	ngOnInit(): void {
		this.condoCorpUrl = UrlService.Matter_Property_CondoCorp(this.saleId);
		this.detailsUrl = UrlService.Matter_Property_Details(this.saleId);
		this.complianceLettersUrl = UrlService.Matter_Property_ComplianceLetters(
			this.saleId,
		);
		this.fireInsuranceUrl = UrlService.Matter_Property_FireInsurance(
			this.saleId,
		);
	}
}
